<template>
  <div class="w-full">
    <div class="flex flex-row-reverse "> 
      <div>   <Lynx-Label label="Carteiras" />
    <b-select 
    placeholder="Selecione as carteiras..."
          style=" width: 100%;border-radius: 10px; border: 4px solid #0d0e46;"
    name="form-class" id="" v-model="carteiraOnb" >
      <option value="0"> Todos</option>
      <!-- <option value="10">Onboarding 1</option> -->
      <option value="16">Onboarding 2</option>
          <option value="23">Onboarding 3</option>
      <!-- <option value="11">Onboarding Atletica</option> -->
    </b-select>
    </div>
    </div>


    <div class="my-4 w-full   gap-4" style="min-height: 140px">
   <v-row>


    <v-col md="4"> <CnpjCountStats /></v-col>
    <v-col md="4"> <AlteracaoCountStats /></v-col>
    <v-col md="4"> <BaixaCountStats /></v-col>
    <v-col md="12">   <NewCompaniesCountStats /></v-col>
    <v-col md="6">  <AlvaraCountStats /></v-col>
    <v-col md="6">  <AlvaraRenovacao /></v-col>



   </v-row>
   
    
     
    </div>
    <div class="my-8 w-full " style="min-height: 250px">
      <EmpresaStatus class="h-full" />
    </div>
     <div class="my-8 w-full " style="min-height: 250px">
      <CompaniesTimeByStep class="h-full" />
    </div>
    <div class="my-8 w-full gap-4" style="min-height: 350px">
      <EmpresaCarteira class="h-full" />
    </div>

    <!-- <div class="my-8 w-full gap-4" style="min-height: 350px">
      <AwaitingFinishRegister class="h-full col-span-2" />
    </div> -->
  </div>
</template>

<script>
import EmpresaStatus from "@/views/Home/Onboarding/components/EmpresaStatus";
import CompaniesTimeByStep from "@/views/Home/Onboarding/components/CompaniesTimeByStep";
// import AwaitingFinishRegister from "@/views/Home/Onboarding/components/AwaitingFinishRegister";
import AlvaraCountStats from "@/views/Home/Onboarding/components/AlvaraCountStats";
import AlvaraRenovacao from "@/views/Home/Onboarding/components/AlvaraRenovacao";

import CnpjCountStats from "@/views/Home/Onboarding/components/CnpjCountStats";
import BaixaCountStats from "@/views/Home/Onboarding/components/BaixaCountStats";
import AlteracaoCountStats from "@/views/Home/Onboarding/components/AlteracaoCountStats";


import NewCompaniesCountStats from "@/views/Home/Onboarding/components/NewCompaniesCountStats";
import EmpresaCarteira from "@/views/Home/Onboarding/components/EmpresaCarteira";
export default {
  name: "Onboarding",
  components: {
    NewCompaniesCountStats,
    AlvaraCountStats,
    // AwaitingFinishRegister,
    CompaniesTimeByStep,
    EmpresaStatus,
    EmpresaCarteira,
    CnpjCountStats,
    AlteracaoCountStats,
    BaixaCountStats,
    AlvaraRenovacao
  },
  data() {
    return { carteiraOnb: 16 };
  },
  created() {
    this.onboardingSearch();
  },
  watch: {
    carteiraOnb() {
      this.onboardingSearch();
    },
  },
  methods: {
    async onboardingSearch() {
      await this.$store.dispatch(
        "configEmpresa/onboardingSearch",
        this.carteiraOnb
      );
    },
  },
};
</script>

<style scoped>
</style>
